export const returnTrueDate = (dateString, hours = 0, minutes = 0) => {
	if (dateString) {
		const dateArray = dateString.split('-');
		const year = dateArray[0];
		const month = parseInt(dateArray[1], 10) - 1;
		const date = dateArray[2];
		return new Date(year, month, date, hours, minutes);
	}
};
